// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".countdown__inner{display:flex}.countdown__el{margin-right:3px}.countdown--special{color:#171933;font-size:3.6rem;line-height:4.5rem}.countdown--special .countdown__el{margin-right:0}.countdown--special .countdown__separator{margin:0 1rem}.countdown--special .countdown__singleNumber{display:inline-flex;margin-right:.5rem}.countdown--special .countdown__singleNumber:last-of-type{margin-right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
